import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(private router: Router) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request.headers.append('X-Requested-With', 'XMLHttpRequest');
    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (this.handleError(err)) {
            return throwError(() => err);
          } else {
            return of(null);
          }
        }
        return throwError(() => err);
      }));
  }

  private handleError(err: HttpErrorResponse): boolean {
    if (err.status == 200 && err.url.toLowerCase().includes("account/login")) {
      window.location.reload();
      return false;
    }
    return true;
  }
}
